import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import ReactModal from 'react-modal';
import Formsy from 'formsy-react';

import './OrganizationsMenuNewButton.css';

import Button from '../../components/UIKit/Button';
import Input from '../../components/Formsy/Input';
import AddIcon from '../UIKit/AddIcon';

ReactModal.setAppElement('#root');

class OrganizationsMenuNewButton extends Component {
  constructor () {
    super();
    this.state = {
      showModal: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal () {
    this.setState({ showModal: true });
  }

  closeModal () {
    this.setState({ showModal: false });
  }

  async createOrganization({ name }) {
    const { uid } = this.props.auth;

    try {
      await this.props.firebase
        .pushWithMeta('organizations', {
          name,
          members: {
            [uid]: true,
          },
          owners: {
            [uid]: true,
          },
          projects: [],
          details: [
            { key: 'key', value: 'value' },
          ],
        });

      this.refs.createOrganizationForm.reset();

      this.closeModal();
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    const { showModal } = this.state;

    return (
      <div className="OrganizationsMenuNewButton">
        <button
          className="OrganizationsMenuNewButton__button"
          onClick={this.openModal}
        >
          <span className="OrganizationsMenuNewButton__button__icon">
            <AddIcon />
          </span>
          <span className="OrganizationsMenuNewButton__button__text">
            New Organization
          </span>
        </button>
        <ReactModal
          isOpen={showModal}
          onRequestClose={this.closeModal}
          overlayClassName="OrganizationsMenuNewButton__overlay"
          className="OrganizationsMenuNewButton__modal"
        >
          <h2>
            Create new organization
          </h2>
          <Formsy
            ref="createOrganizationForm"
            onValidSubmit={(data) => {
              this.createOrganization(data);
            }}
            style={{ margin: '20px auto', width: '100%' }}
          >
            <Input name="name" placeholder="Organization name" value="" required autoComplete="off" />
            <div className="OrganizationsMenuNewButton__modal__submit">
              <button className="OrganizationsMenuNewButton__modal__submit__button" type="submit">
                Submit
              </button>
            </div>
          </Formsy>
        </ReactModal>
      </div>
    );
  }
}

export default compose(
  connect(({ firebase }) => ({ auth: firebase.auth })),
  firebaseConnect(),
)(OrganizationsMenuNewButton);



// WEBPACK FOOTER //
// ./src/components/OrganizationsMenuNewButton/OrganizationsMenuNewButton.jsx